import React, { useContext } from "react";
import { AuthContext } from "../app-context/AuthContext";
import { NavLink, useNavigate } from "react-router-dom";

const Header = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const logoutHandler = () => {
    navigate("/login");
    logout();
    window.location.reload();
  };

  return (
    <nav className="p-4 bg-red-500 text-white">
      <div className="container mx-auto flex justify-between">
        <div className="text-xl font-bold">NSRGFX MOVIES</div>
        <div>
          {user ? (
            <>
              <span className="mr-4">{user}</span>
              <button onClick={logoutHandler} className="mr-4">
                Logout
              </button>
            </>
          ) : (
            <NavLink to="/login" className="mr-4">
              Login
            </NavLink>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Header;
